const PestControlIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 87"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="pest_control"
    fill="none"
  >
    <title>a-icons / 32px / services / pest_control</title>
    <path
      d="M26.3096 36.4664L31.3709 51.6385L36.3403 55.925L51.6161 61.5953C57.8737 63.8711 63.7325 61.5953 65.8797 60.1729L86.583 38.3982C90.6321 34.2259 87.3519 28.0901 85.6648 25.0873L80.6035 18.9236L63.5791 2.8032C56.5853 -0.989836 51.1559 2.17103 49.3155 4.22559L28.1501 26.0355C25.5734 29.4493 25.8495 34.4118 26.3096 36.4664Z"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <path
      d="M53.6943 17.0225L50.3637 13.2018C49.7071 12.4486 49.6989 11.3137 50.4263 10.6287C55.1356 6.19413 60.1584 6.71554 62.6513 8.49626C63.4148 9.04168 63.3193 10.1084 62.671 10.7868L56.6479 17.09C55.8352 17.9406 54.4674 17.9093 53.6943 17.0225Z"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <path
      d="M38.7714 35.3942L35.4605 38.6858C34.7417 39.4004 33.5765 39.4795 32.9032 38.7215C29.6722 35.0838 31.1572 30.8309 32.9524 28.6183C33.5768 27.8486 34.6893 27.986 35.35 28.7251L38.8522 32.643C39.5609 33.4358 39.5254 34.6445 38.7714 35.3942Z"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <path
      d="M72.5621 32.6402L78.4092 27.1178C79.3209 26.2567 80.8052 26.4307 81.3067 27.576C83.8459 33.375 81.133 38.1869 78.5136 39.8727C77.8907 40.2736 77.1059 40.0657 76.5821 39.545L72.5213 35.5079C71.7225 34.7137 71.7409 33.4158 72.5621 32.6402Z"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <path
      d="M56.4969 49.4184L61.4106 53.6649C62.3358 54.4645 62.334 55.9217 61.2781 56.5428C56.6223 59.2816 52.3388 57.4938 50.6168 55.402C50.1621 54.8497 50.277 54.0723 50.7117 53.5026L53.5965 49.7214C54.2966 48.8037 55.6251 48.665 56.4969 49.4184Z"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <rect
      x="1.41833"
      y="-0.00280154"
      width="11.7428"
      height="11.6131"
      rx="1"
      transform="matrix(0.707774 -0.706439 0.710559 0.703638 58.6667 23.0257)"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <rect
      x="1.41833"
      y="-0.00280154"
      width="11.7428"
      height="11.6131"
      rx="1"
      transform="matrix(0.707774 -0.706439 0.710559 0.703638 46.4489 35.2655)"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <rect
      x="1.41833"
      y="-0.00280154"
      width="11.7428"
      height="11.6131"
      rx="1"
      transform="matrix(0.707774 -0.706439 0.710559 0.703638 34.6167 47.0289)"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <path
      d="M43.2344 30.0433L36.5288 23.4031L44.836 15.1116C44.8363 15.1112 44.8366 15.111 44.8368 15.1108C44.8373 15.1107 44.8384 15.1104 44.8401 15.1104C44.8418 15.1104 44.8429 15.1107 44.8433 15.1108C44.8435 15.111 44.8438 15.1112 44.8442 15.1116L51.5498 21.7518L43.2426 30.0433C43.2422 30.0437 43.2419 30.044 43.2418 30.0441C43.2413 30.0443 43.2402 30.0445 43.2385 30.0445C43.2368 30.0445 43.2357 30.0443 43.2352 30.0441C43.2351 30.044 43.2348 30.0437 43.2344 30.0433ZM65.9887 52.6652L59.2831 46.025L67.5903 37.7335C67.5906 37.7331 67.5909 37.7329 67.5911 37.7327C67.5916 37.7326 67.5927 37.7323 67.5944 37.7323C67.5966 37.7323 67.5978 37.7327 67.5979 37.7328L67.5978 37.7328L67.5977 37.7327L67.5976 37.7326C67.5978 37.7328 67.5981 37.7331 67.5985 37.7335L74.3041 44.3737L65.9969 52.6652C65.9965 52.6656 65.9962 52.6659 65.9961 52.666C65.9956 52.6661 65.9945 52.6664 65.9928 52.6664C65.9911 52.6664 65.99 52.6662 65.9895 52.666C65.9894 52.6659 65.9891 52.6656 65.9887 52.6652ZM67.5975 37.7326C67.5973 37.7325 67.5974 37.7325 67.5975 37.7326L67.5975 37.7326Z"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <path
      d="M24.859 57.3799L29.2659 61.7436L8.54353 82.4283C7.33145 83.6382 5.36235 83.6422 4.14542 82.4372C2.92849 81.2322 2.92456 79.2745 4.13664 78.0647L24.859 57.3799Z"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
    <rect
      x="1.41818"
      y="-0.0208193"
      width="8.32962"
      height="7.98492"
      rx="1"
      transform="matrix(0.698741 -0.715374 0.71944 0.694555 23.7286 57.3854)"
      stroke={color || '#00008F'}
      strokeWidth="2"
    />
  </svg>
);

export default PestControlIcon;
